import axios from 'axios';

const getStaffDetails = (mobileNumber) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/staff/${mobileNumber}`)
    .then(res => res)
    .catch(err => err);
};

export default getStaffDetails;
